import React from 'react';
import Handle from './Handler';
import NodeWrapper, {Title} from './NodeWrapper';

const CustomInput = (props) => {
  return (
    <NodeWrapper {...props}>
      <Handle type="source" node="rrdef" position="left" style={{top: 10, background: '#555'}} />
      <Handle type="target" node="rrdef" position="left" style={{bottom: 10, top: 'auto', background: '#555'}} />
      <div>
        <Title title={props.data.label} />
      </div>
      <Handle type="source" node="rrdef" position="right" />
    </NodeWrapper>
  );
};

export default CustomInput;
